import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Box, Button, IconButton } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { ModalButton } from "../../pages/Mint/styles";
import { Collaborator } from "../../pages/Mint/types";
import { MintAddCollabModalProps } from "./types";
import { mintAddCollaboratorModalStyles } from "./styles";
import { APP_BACKGROUND_COLOR, APP_COLOR, FONT_FAMILY } from "../../theme";

export const MintAddCollabModal: React.FC<MintAddCollabModalProps> = ({
  prevCollabs,
  setPrevCollabs,
  isSubmitting,
  addCollaborator,
  setFieldError,
}) => {
  return (
    <>
      <Modal
        isOpen={prevCollabs.length !== 0}
        centered
        contentClassName={"no-border"}
        toggle={() => setPrevCollabs([])}
        backdrop={true}
        keyboard={false}
        style={{ fontFamily: FONT_FAMILY }}
      >
        <ModalHeader style={{ backgroundColor: APP_BACKGROUND_COLOR }}>
          Adding Collaborators
        </ModalHeader>
        <ModalBody style={mintAddCollaboratorModalStyles.modalBody}>
          Select the split revenue for existing collaborators:
          <Box sx={{ marginTop: 2 }}>
            {prevCollabs.map((collaborator: Collaborator) => (
              <div className="collaborator" key={collaborator.username}>
                <p style={{ fontFamily: FONT_FAMILY, flexGrow: 1 }}>
                  {collaborator.username}
                </p>
                <p style={{ fontFamily: FONT_FAMILY }}>
                  <input
                    style={{ width: 50, padding: "0 5px" }}
                    type="number"
                    step="1"
                    onChange={(event) =>
                      (collaborator.share = event.target.value)
                    }
                    disabled={isSubmitting}
                    min="0"
                    max="100"
                  />
                  {"  %"}
                </p>
                {!isSubmitting && (
                  <IconButton
                    onClick={() => {
                      const updatedCollaborators = prevCollabs.filter(
                        (item: Collaborator) =>
                          item.username !== collaborator.username
                      );
                      setPrevCollabs(updatedCollaborators);
                    }}
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                )}
                <Button
                  size="small"
                  variant="contained"
                  disableFocusRipple
                  onClick={() => {
                    if (collaborator.share && collaborator.username) {
                      const updatedCollaborators = prevCollabs.filter(
                        (item: Collaborator) =>
                          item.username !== collaborator.username
                      );
                      setPrevCollabs(updatedCollaborators);
                      addCollaborator(collaborator, setFieldError);
                    }
                  }}
                  style={{ backgroundColor: APP_COLOR, textTransform: "none" }}
                >
                  Add
                </Button>
              </div>
            ))}
          </Box>
          <Box sx={{ alignSelf: "center" }}>
            <ModalButton
              sx={{ marginRight: 2 }}
              size="small"
              variant="contained"
              disableFocusRipple
              onClick={() => {
                setPrevCollabs([]);
              }}
            >
              Dismiss
            </ModalButton>
          </Box>
        </ModalBody>
      </Modal>
    </>
  );
};
